import React, { Component } from 'react'
import { when } from "mobx"
import { observer } from "mobx-react"
import { List, Icon } from 'antd';
import { Provider } from "mobx-react"
import EventsByCategory from "../layoutComponents/EventsByCategory";
@observer(["CategoriesStore", "TeamStore", "AdminStore", "ViewStore", "eventStore", "web3Store"])
class CategoryListItems extends Component {
    render() {
        const list = [];
        this.props.CategoriesStore.categories.forEach((category) => {
            list.push(<List.Item key={category.title} style={{ padding: "15px" }}>
                <EventsByCategory oracles={this.props.oracles} category={category._id} eventList={this.props.eventList} />
            </List.Item>)
        });

        list.sort((a,b) => {            
            return a.key > b.key;
        });
        return (
            <div>
                {this.props.CategoriesStore.loading ? <Icon style={{ fontSize: "50pt" }} type="loading" /> : ""}
                <List
                    grid={{
                        gutter: 16, xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 2,
                    }} >
                    {list}
                </List>
            </div>
        )
    }
}
export default CategoryListItems;



// WEBPACK FOOTER //
// ./src/components/appComponents/CategoryListItems.js